import { Seo } from "../components/Seo";

const SECTIONS = [
    {
        h: "1. O serviço",
        body: "O ScorpionPDF oferece ferramentas online gratuitas para manipulação de arquivos PDF e imagens, sem necessidade de cadastro. O serviço é fornecido 'como está', com o objetivo de ser útil e confiável, mas sem garantia de disponibilidade ininterrupta.",
    },
    {
        h: "2. Uso aceitável",
        body: "Você se compromete a usar as ferramentas apenas para fins lícitos e com arquivos que tem o direito de processar. É proibido tentar sobrecarregar, burlar limites, explorar vulnerabilidades ou usar o serviço para distribuir conteúdo ilegal.",
    },
    {
        h: "3. Limites técnicos",
        body: "Aplicamos limites de tamanho (25 MB por arquivo), quantidade (10 arquivos por operação), páginas (200 por documento) e frequência de uso para manter o serviço estável para todos. Esses limites podem ser ajustados a qualquer momento.",
    },
    {
        h: "4. Seus arquivos",
        body: "Os arquivos enviados continuam sendo seus. Não reivindicamos qualquer direito sobre o conteúdo. Eles são processados exclusivamente para executar a operação que você pediu e excluídos automaticamente em até 60 minutos.",
    },
    {
        h: "5. Limitação de responsabilidade",
        body: "Fazemos o possível para gerar resultados corretos, mas não garantimos preservação perfeita de todos os recursos de um PDF (formulários interativos, assinaturas digitais e camadas complexas podem não ser mantidos). Verifique sempre o arquivo resultante antes de descartar o original. Não nos responsabilizamos por perdas decorrentes de uso indevido ou de indisponibilidades temporárias.",
    },
    {
        h: "6. Planos futuros",
        body: "Poderemos oferecer planos pagos com limites ampliados no futuro. As ferramentas básicas gratuitas continuarão disponíveis. Nenhuma cobrança será feita sem contratação expressa.",
    },
    {
        h: "7. Legislação aplicável",
        body: "Estes termos são regidos pelas leis brasileiras. Texto preparado para revisão jurídica antes da publicação definitiva.",
    },
];

export default function TermsPage() {
    return (
        <main className="py-14 px-6 max-w-3xl mx-auto min-h-[60vh]">
            <Seo
                title="Termos de uso — ScorpionPDF"
                description="Condições de uso das ferramentas gratuitas de PDF: limites técnicos, uso aceitável e responsabilidades."
            />
            <span className="font-mono-tag text-xs font-bold text-[#0284C7] uppercase">Documento</span>
            <h1 className="font-poster text-5xl md:text-6xl text-black mt-1">Termos de uso</h1>
            <div className="mt-10 space-y-6">
                {SECTIONS.map((s) => (
                    <section key={s.h} className="border-2 border-black bg-white p-6">
                        <h2 className="font-bold text-black">{s.h}</h2>
                        <p className="text-sm text-gray-700 mt-2 leading-relaxed">{s.body}</p>
                    </section>
                ))}
            </div>
        </main>
    );
}
